import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font,
  Image as PDFImage
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 1.5,
    width: '120%'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 20,
    marginBottom: 20,
    padding: 10,
    borderRadius: 8,
    paddingTop: '90px',
    paddingLeft: '0px'
  },
  column: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    gap: 6, // Reduced gap to keep the items close together
    padding: 8
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 3 // Reduced margin bottom
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10,
    color: '#333' // Added color for label text
  },
  value: {
    fontSize: 10,
    fontWeight: 'normal',
    width: '70%', // Adjusted width of value text to fit nicely
    color: '#555' // Added color for value text
  },
  // Improved spacing between the columns in contentContainer3
  contentContainer3: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    borderTop: '1px solid #ddd',
    paddingTop: 10
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationPdf4 = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const ageString = data.age;
  const years = ageString.match(/\d+Y/);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.name} Registration`}>
          <Page size="A4" style={styles.page}>
            <PDFImage src="/Pdf Print Format.png" style={{ width: '100%', height: '100%', }} />
          </Page>
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="Patient Name    :  "
                  style={{ fontSize: 10, fontWeight: 'bold', fontFamily: 'Roboto' }}
                />
                <Text content={`${data.name}`} />
              </View>
              <View style={styles.row}>
                <Text content="Address             :  " style={{ fontSize: 10, fontFamily: 'Roboto' }} />
                <Text content={`${data.address}`} />
              </View>
              <View style={styles.row}>
                <Text content="Age/Sex             :  " style={{ fontSize: 10, fontFamily: 'Roboto' }} />
                <Text content={`${data?.age}/${data?.gender}`} />
              </View>
              <View style={styles.row}>
                <Text content="Visit Date           :  " style={{ fontSize: 10, fontFamily: 'Roboto' }} />
                <Text content={`${formatDate(data.reg_date)}${data.reg_time}`} />
              </View>
              <View style={styles.row}>
                <Text content="Department       :  " style={{ fontSize: 10, fontFamily: 'Roboto' }} />
                <Text content={`${data.department}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Father Name           :   " style={{ fontSize: 10, fontFamily: 'Roboto' }} />
                <Text content={`${data.guardian_name}`} />
              </View>
              <View style={styles.row}>
                <Text style={{ fontSize: 10, fontFamily: 'Roboto' }} content="OPD No.                   :     " />
                <Text content={` ${data.op_no}`} />
              </View>
              <View style={styles.row}>
                <Text content="Registration No      :   " style={{ fontSize: 10, fontFamily: 'Roboto' }} />
                <Text content={`${data.uhid}`} />
              </View>
              <View style={styles.row}>
                <Text content="Appointment Type  :  " style={{ fontSize: 10, fontFamily: 'Roboto' }} />
                <Text content={`${data.opd_type}`} />
              </View>
              <View style={styles.row}>
                <Text content="Phone No                 :  " style={{ fontSize: 10, fontFamily: 'Roboto' }} />
                <Text content={`${data.mobile}`} />
              </View>
            </View>
          </View>
        </Document>
      </PDFViewer>
    </div>
  );
};
